// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 2730) return "static/chunks/2730-c215ec1f984a4643.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 501 ? "bc98253f" : chunkId) + "." + {"501":"8284d98edc2c9a13","5283":"c8ad58acbe330a11","6029":"44b10292846c6502","7379":"6c0b1a8990a1c7e9","7816":"4033f72627111700"}[chunkId] + ".js";
};